import { caseNameUpdateAction } from '../actions/form';
import { selectCustomerAction } from '../actions/customers';
import { selectSiteAction, unselectSiteAction } from '../actions/sites';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [caseNameUpdateAction]: (state, action) => true,
  [selectSiteAction]: (state, action) => true,
  [unselectSiteAction]: (state, action) => true,
  [selectCustomerAction]: (state, action) => true,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/reducers/dirty.js